module.exports = __webpack_public_path__ + "static/inside_video_main_s2-1de249747218a3fdb74e90b406bd9a1c.mp4";